import { cn } from "../lib/utils";

/** 52px: the 11mm of the printed band, and every clearance kept from it. */
const width = "w-[52px]";

export const hatchBandFooterEdge = "pr-[76px] lg:mr-[52px] lg:pr-12";

export const hatchBandInset = "lg:pr-[52px]";

/** The huisstijl's hatch band down the right edge, from lg up; a phone gets it over the footer. */
export function HatchBand({ className }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={cn(
        "jb-hatch-band pointer-events-none fixed inset-y-0 right-0 z-10 hidden lg:block",
        width,
        className,
      )}
    />
  );
}

export function HatchBandCorner() {
  return (
    <div
      aria-hidden
      className="jb-hatch-band jb-hatch-corner pointer-events-none absolute right-0 hidden lg:block"
    />
  );
}

export function HatchBandOverFooter() {
  return (
    <div
      aria-hidden
      className={cn("jb-hatch-band pointer-events-none absolute inset-y-0 right-0 lg:hidden", width)}
    />
  );
}
